import { Patient } from "../../patient";
import { ReceptionPermissions } from "../reference";

// 依頼受付インデックス
export class ReceptionSummary {
  public id: number;
  public status: string;
  public receptionNumber: string;
  public receptionDate: Date;
  public patient: Patient;
  public isTemporary: boolean;
  public deleted: boolean;
  public hasDeletedDetail: boolean;
  public permissions: ReceptionPermissions;

  clone(): ReceptionSummary {
    const newObj = new ReceptionSummary();
    newObj.id = this.id;
    newObj.status = this.status;
    newObj.receptionNumber = this.receptionNumber;
    newObj.receptionDate = this.receptionDate;
    newObj.patient = this.patient;
    newObj.isTemporary = this.isTemporary;
    newObj.deleted = this.deleted;
    newObj.hasDeletedDetail = this.hasDeletedDetail;
    newObj.permissions = this.permissions;

    return newObj;
  }
}
